if ($('.filter-section').length) {
    function mhfilter() {
      $('.filter-section h4').click(function () {
        $('.filter-section').not($(this).closest('.filter-section')).removeClass('openFilter').removeAttr('style');
        var section = $(this).closest('.filter-section');
        section.toggleClass('openFilter');
       
    });
    }
  
    $(document).ready(function () {
      mhfilter();
    });
    document.addEventListener('ShoptetDOMContentLoaded', function () {
      mhfilter();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
      mhfilter();
    });
    document.addEventListener('ShoptetPageFilterValueChange', function () {
      mhfilter();
    });
    
}  